export const optionsTipoLivro = [
  { value: null, text: 'Selecione' },
  { value: 'N', text: 'Nascimento' },
  { value: 'C', text: 'Casamento' },
  { value: 'O', text: 'Óbito' },
  { value: 'NT', text: 'Natimorto' },
  { value: 'CR', text: 'Casamento Religioso' },
]

export function findTipoLivroByValue (value) {
  const itemFound = optionsTipoLivro.find(item => item.value === value)
  return itemFound ? itemFound : { value, text: value }
}
